exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul[data-v-7fe544a7]{\n    padding: 0;\n    margin: 0;\n}\nli[data-v-7fe544a7]{\n    list-style: none;\n}\np[data-v-7fe544a7]{\n    margin: 0;\n}\ntextarea[data-v-7fe544a7]{\n    width: 100%;\n    white-space: pre-wrap;\n    resize: none;\n}\n", ""]);

// exports
